import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import {
    buildGA4ItemsFromCartLines,
    getCurrencyCode,
    trackGA4AddPaymentInfo,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4AddPaymentInfoEvent: typeof PopulateApiParameter = props => {
    if (!props.cartToUpdate?.cartLines?.length) {
        return;
    }

    const currency = getCurrencyCode(props.getState());
    const paymentType =
        props.cartToUpdate.paymentMethod?.name || props.parameter.paymentMethod || "Unknown";
    const items = buildGA4ItemsFromCartLines(props.cartToUpdate.cartLines);

    trackGA4AddPaymentInfo(
        items,
        currency,
        props.cartToUpdate.orderGrandTotal,
        paymentType,
        props.cartToUpdate.promotionCode || undefined,
    );
};

addToChainBefore(chain, PopulateApiParameter, SendGA4AddPaymentInfoEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
